export default __webpack_public_path__ + "static/media/image-17.23ede650.png";